import product from '../objects/product/index';

// run all related funcs here
product();
